module.exports = new __parcel__URL__("warningTriangleIcon.e9f92055.svg").toString();